export default "__VITE_ASSET__DpfQBv92__"